/**
 * Input limits shared by the Imaging Profile page and Imaging Onboarding, so both forms
 * accept exactly the same data.
 *
 * The "About the Imaging Center" limit matches the doctor bio limit (500) and keeps the text
 * readable in the patient app's imaging center card and profile.
 */
export const BIO_MAX_LENGTH = 500;
